
import AddToCartError from './AddToCartError.vue';
import UiButton from 'JS/components/UiButton.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RequireAgreementResponse } from 'JS/services/ProductService';

@Component({
	name: 'ProductAgreement',
	components: {
		AddToCartError,
		UiButton
	}
})
export default class DeliveryConfirmationSidebar extends Vue {
	@Prop({ type: Object as PropType<RequireAgreementResponse>, required: true })
	readonly productAgreement: RequireAgreementResponse;
}
